import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { AuthService } from "angularx-social-login";
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  title = 'FAQs | Workspace | Crafttor';
  isShown: boolean = false;
  upDown: boolean = true;
  currentUser: User;
  currentValue: string;
  mobileView: boolean = false;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'A user can get all the answers to their questions in the FAQ section of Crafttor Workspace.'},
      { name: 'keywords', content: 'workspace, Workspace, faq, FAQ, questions, query questions, designs.' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) {
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }
}
